import React, { useEffect } from 'react';

import Text from '@sats-group/ui-lib/react/text/text';

import Logo from 'shared/components/logo/logo';
import type { NamedFC } from 'shared/types/named-fc.types';

import { AppStoreLogo } from 'ui/components/app-store-logo/app-store-logo';
import { GooglePlayStoreLogo } from 'ui/components/google-play-store-logo/google-play-store-logo';

import type { AppDownloadRedirect as Props } from './app-download-redirect.props';

const AppDownloadRedirect: NamedFC<Props> = ({
  appStoreHref,
  googlePlayHref,
  logo,
  title,
}) => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    const isIOS =
      /iPad|iPhone/.test(userAgent) ||
      (navigator.userAgent.includes('Macintosh') &&
        navigator.maxTouchPoints > 1);
    const isAndroid = /android/i.test(userAgent);

    if (isIOS) {
      window.location.href = appStoreHref;
    } else if (isAndroid) {
      window.location.href = googlePlayHref;
    }
  }, []);

  return (
    <div className="app-download-redirect">
      <div className="app-download-redirect__logo">
        <Logo {...logo} />
      </div>
      <Text size={Text.sizes.headline3}>{title}</Text>
      <div className="app-download-redirect__app-links">
        <a href={googlePlayHref}>{<GooglePlayStoreLogo />}</a>
        <a href={appStoreHref}>{<AppStoreLogo />}</a>
      </div>
    </div>
  );
};

AppDownloadRedirect.displayName = 'AppDownloadRedirect';

export default AppDownloadRedirect;
